export enum RequestResultModalType {
  AuthError = 'auth_error',
  ConnectionError = 'connection_error',
  NotEnoughResources = 'not_enough_resources',
}
